import React from "react";
import { InputNumber, Row, Col, Card } from "antd";
import { $t } from "~/i18n.js";

export default function AddonsSelect({ addons = [], checkoutItem, setCheckoutItem }) {
  // Update quantity and price for an addon
  const handleChange = (id, value) => {
    const newAddons = addons.map((addon) => {
      if (addon.id === id) {
        const qty = parseInt(value) || addon.min_amount || 0;
        return {
          ...addon,
          quantity: qty,
          price: qty * parseFloat(addon.unit_price || 0),
        };
      }
      return addon;
    });
    setCheckoutItem({
      ...checkoutItem,
      addons: newAddons,
    });
  };

  if (!addons.length) return null;

  return (
    <div style={{ marginTop: 16 }}>
      <p className="title spacer label">{$t("Opties")}</p>
      {addons.map((addon) => (
        <Card key={addon.id} size="small" style={{ marginBottom: 8 }}>
          <Row align="middle" gutter={8}>
            <Col flex="auto">
              <div style={{ fontWeight: 500 }}>{addon.description}</div>
              <div style={{ color: '#888', fontSize: 13 }}>
                {addon.unit_price} {addon.unit_price_label}
              </div>
            </Col>
            <Col>
              <InputNumber
                min={addon.min_amount}
                max={addon.max_amount > 0 ? addon.max_amount : undefined}
                step={1}
                value={addon.quantity}
                onChange={(value) => handleChange(addon.id, value)}
                style={{ width: 60 }}
                stringMode={false}
              />
            </Col>
          </Row>
        </Card>
      ))}
    </div>
  );
}
